import { PRIMARY_PRODUCT } from './constants';
import { getInputIntentLocal as getConvergenceInputIntentLocal } from './rules-engine-local-convergence/get-input-intent-local';
import { getInputIntentLocal as getJiraInputIntentLocal } from './rules-engine-local-jira-legacy/get-input-intent-local';
import { type IntentContext, type IntentResponse } from './types';

/**
 * Classifies an input synchronously with the local rules engine selected for
 * the current product context.
 */
export const getInputIntentLocal = (input: string, context: IntentContext = {}): IntentResponse => {
	const shouldUseConvergenceRules =
		context.primaryProduct === PRIMARY_PRODUCT.CONFLUENCE ||
		context.primaryProduct === PRIMARY_PRODUCT.HOME;

	return shouldUseConvergenceRules
		? getConvergenceInputIntentLocal(input)
		: getJiraInputIntentLocal(input, context);
};
